import { useContext, useEffect, useRef, useState } from 'react';
import { getEPOPortDropdown } from '../../apiCalls';
import { GoogleAnalyticsContext } from '../../GoogleAnalytics';
import { Select } from '../../Input/Input';
import { useStepper } from '../../Stepper';
import { StoreContext } from '../../Store';
import cargoShip from '../assets/cargo-ship.png';
import StepWrapper from './StepWrapper';

export function ExitPortPage() {
  const { localData, setDataByKey, activeStepKey, gotoStep } = useStepper();

  const store = useContext(StoreContext);

  const nextPage = () => {
    if (!localData.exitport?.id) {
      setError('Please select a port to continue.');
      return;
    }
    store.lockDirection[1](true);
    gotoStep('4. AdditionalRequirements');
  };

  useEffect(() => {
    getEPOPortDropdown('Export', store.epoDirection[0]).then((data) => {
      store.exitPortOptions[1](data);
    });
  }, [store.epoDirection[0]]);

  const previousPage = () => {
    setError('');
    gotoStep('1. Direction');
  };

  const isInitialized = useRef(false);
  const ga = useContext(GoogleAnalyticsContext);

  useEffect(() => {
    if (ga.gaInitialized) {
      if (activeStepKey === '2. Exit Port' && isInitialized.current === false) {
        isInitialized.current = true;
        window?.gtag?.('event', '2. Exit Port', {
          event_category: 'EPO',
        });
      }
    }
  }, [activeStepKey, ga.gaInitialized]);

  useEffect(() => {
    setError('');
  }, [localData.exitport]);

  const [error, setError] = useState('');

  return (
    <StepWrapper
      stepTitle="Place of Exit"
      stepText="Place of Exit"
      stepKey="2. Exit Port"
      handleNextClick={nextPage}
      handleBackClick={previousPage}
      hideUnlessVisited
    >
      <div className="d-flex justify-content-center step-banner">
        <img src={cargoShip} width="150" height="150" alt="port" className="mt-4 mb-4" />
      </div>
      <div className="d-flex flex-column align-self-center mt-auto ">
        <span className="d-flex align-self-center flex-column  " style={{ maxWidth: '280px', fontWeight: '500' }}>
          Please select the expected Place of
        </span>

        <span className="d-flex align-self-center flex-column  " style={{ maxWidth: '280px', fontWeight: '500' }}>
          Exit for this freight movement.
        </span>
      </div>
      <div className="d-flex flex-column mt-auto" style={{ paddingLeft: '6rem', paddingRight: '6rem' }}>
        <Select
          label="Exit Location"
          name="exitport"
          data={localData.exitport?.id}
          onChangeAsObject={(data) => setDataByKey('exitport', data)}
          options={store.exitPortOptions[0]}
          filter={1}
          required
          data-testid="exitLocation-dropdown"
        />
      </div>
      <div className="px-3 mb-3 w-75 mx-auto">
        {error && (
          <div className="alert-danger px-3 py-1 w-100 text-center" style={{ borderRadius: '10px' }}>
            {error}
          </div>
        )}
      </div>
    </StepWrapper>
  );
}
